import { getGalleryInfo } from '../gallery/galleryHeight';
import { getCurrentSettings } from '../gallery/gallerySettings';
import { LAYOUTS } from '../../constants/settingsConstants';
import { FETCH_SURROUNDING_POSTS_NUM } from '../../constants';

const urlWindow = new URL(window.location.href);

export const getInstance = () => {
  const instance = urlWindow.searchParams.get('instance');
  return instance || 'no instance found';
};

export const getCompId = () => {
  return window.Wix.Utils.getOrigCompId() || window.Wix.Utils.getCompId();
};

export const isMobile = () => {
  const deviceType = urlWindow.searchParams.get('deviceType');
  return deviceType === 'mobile';
};

export const createHeaders = (accessToken, userId, isBusinessApp) => {
  return {
    'x-instagram-token': accessToken,
    'x-instagram-user-id': userId,
    'x-is-business-app': isBusinessApp,
  };
};

export const buildError = (code, message) => {
  return {
    code,
    status: code,
    message: {
      code,
      message,
    },
  };
};

export const getWidthElement = (element) => {
  if (element) {
    const style = element.currentStyle || window.getComputedStyle(element),
      width = element.offsetWidth,
      margin = parseFloat(style.marginLeft) + parseFloat(style.marginRight),
      border =
        parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth);

    return width + margin + border;
  }
  return 0;
};

export const convertDataToProGalleryItems = (medias, isHashtag) => {
  const isMobileDevice = isMobile();
  if (medias && medias.length) {
    return medias.map((media) => {
      const isPrivateAccount = media.type;
      if (isPrivateAccount) {
        media = fixMedia(media);
      }
      const isVideo = media.media_type === 'VIDEO';
      if (isVideo && isHashtag && !media.thumbnail_url) {
        media.thumbnail_url = media.media_url;
      }
      const mediaData = {
        itemId: media.id,
        mediaUrl:
          isVideo && isMobileDevice ? media.thumbnail_url : media.media_url,
        originalData: media,
        metaData: {
          type: isVideo && !isMobileDevice ? 'video' : 'image',
          title: media.text,
          description: media.text,
          poster: {
            url: isVideo ? media.thumbnail_url || media.media_url : '',
          },
          link: {
            url: media.permalink,
            target: '_blank',
          },
        },
      };

      return mediaData;
    });
  }

  return [];
};

const fixMedia = (media) => {
  media.media_type =
    media.type.toUpperCase() === 'CAROUSEL'
      ? 'CAROUSEL_ALBUM'
      : media.type.toUpperCase();
  media.comments_count = media.comments.count;
  media.like_count = media.likes.count;
  media.media_url = media.videos
    ? media.videos.standard_resolution.url
    : media.images.standard_resolution.url;
  media.text = media.caption.text ? media.caption.text : '';
  media.permalink = media.link;
  media.thumbnail_url = media.videos
    ? media.images.standard_resolution.url
    : '';

  if (media.carousel_media) {
    media.carousel_media = media.carousel_media.map((caruselMedia) => {
      const isVideo = caruselMedia.type.toUpperCase() === 'VIDEO';

      return {
        media_url: isVideo
          ? caruselMedia.videos.standard_resolution.url
          : caruselMedia.images.standard_resolution.url,
        media_type: caruselMedia.type.toUpperCase(),
        thumbnail_url: isVideo
          ? caruselMedia.images.standard_resolution.url
          : '',
      };
    });
  }

  return media;
};

export const getCountImageNeedToDisplay = (type) => {
  const { galleryLayout } = getGalleryInfo(type);
  switch (galleryLayout) {
    case LAYOUTS.GRID:
      const { numberOfImagesPerRow, numRows } = getCurrentSettings(type);
      return numberOfImagesPerRow * numRows;
    case LAYOUTS.COLLAGE:
      const { loadItemsOnSection, countBlocksDisplay } = getCurrentSettings(
        type,
      );
      return loadItemsOnSection * countBlocksDisplay;
    case LAYOUTS.SLIDER:
      const { countItemsSlider } = getCurrentSettings(type);
      return countItemsSlider;
    default:
      break;
  }
};

export const getCountParam = (type) => {
  const totalFeedPosts = getCountImageNeedToDisplay(type);
  const count =
    totalFeedPosts < 20 ? totalFeedPosts + 20 : totalFeedPosts * 2 + 1;
  return count;
};

export const stringifyErrMsg = (str) => {
  if (typeof str === 'string') return str;
  if (typeof str === 'object')
    try {
      return stringifyErrMsg(str.message);
    } catch (err) {
      return JSON.stringify(str);
    }
};
// Creating links and ids array after generating start and end points around current item
export const createDataForLinksAndComments = (
  currentIndex,
  medias,
  currentLinks,
) => {
  let mediaIdsArr = [];
  const mediaLinksArr = [];

  const end =
    currentIndex + FETCH_SURROUNDING_POSTS_NUM > medias.length - 1
      ? medias.length - 1
      : currentIndex + FETCH_SURROUNDING_POSTS_NUM;

  const start =
    currentIndex - FETCH_SURROUNDING_POSTS_NUM < 0
      ? 0
      : currentIndex - FETCH_SURROUNDING_POSTS_NUM;
  const newIndex = currentIndex - start;

  for (let i = start; i <= end; i++) {
    const media = medias[i].originalData || medias[i];
    const mediaId = media.id;
    const mediaLink = media.permalink;
    mediaIdsArr.push(mediaId);
    mediaLinksArr.push(mediaLink);
  }
  // In order to make calls for new posts remove existing IDs
  mediaIdsArr = removeDuplicates(mediaIdsArr, currentLinks);

  return {
    mediaIdsArr,
    mediaLinksArr,
    newIndex,
  };
};

export const falsifyKeys = (obj) => {
  const newObj = {};
  Object.keys(obj).forEach((id) => (newObj[id] = false));
  return newObj;
};

const removeDuplicates = (newArray, objFromState) => {
  if (!Object.keys(objFromState).length) return newArray;
  return newArray.filter((mediaId) => !objFromState[mediaId]);
};

export const combineMaps = (map1, map2) => {
  if (map1) {
    return new Map([...map1, ...map2]);
  } else {
    return map2;
  }
};

export const checkUrlType = (url) => {
  // Extract file extension from the URL
  try {
    const baseUrl = url.split('?');
    const extension = baseUrl[0].split('.').pop().toLowerCase();
    console.log('extension', extension, baseUrl);

    // Define common image and video file extensions
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
    const videoExtensions = ['mp4', 'webm', 'ogg'];

    // Check if the extension is in the list of image extensions
    if (imageExtensions.includes(extension)) {
      return 'image';
    }

    // Check if the extension is in the list of video extensions
    if (videoExtensions.includes(extension)) {
      return 'video';
    }
  } catch (e) {
    return 'video';
  }
};
